import { useState, useContext } from "react";
import { useSelector } from "react-redux";
import { Input, Image, Form, Table, notification } from "antd";

import EN from "../../../../../config/en";
import ICONS from "../../../../../config/icons";
import { TMDB_IMAGE_HOST } from "../../../../../server/tmdb";

import LabelComponent from "../../../../elements/LabelComponent";

import TmdbSearch from "./search/TmdbSearch";
import REQUESTS from "../../../../../server/requests";
import SaveButtonComponent from "../../../../elements/SaveButtonComponent";
import Context from "./Context";
import ErrorMessage from "../../../../elements/ErrorMessage";
import { useEffect } from "react";
import { dateFormat } from "../../../../../config/formats";

export default function FromTmdbTabPane({ activeKey }) {
  const { getMovesList, visibleAddMovieDrawer, setVisibleAddMovieDrawer } =
    useContext(Context);

  const translate = useSelector((state) => state.globalState.translate);

  const [poster, setPoster] = useState("error");
  const [backdrop, setBackdrop] = useState("error");
  const [tmdbId, setTmdbId] = useState(null);

  const [seasons, setSeasons] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState(null);

  useEffect(() => {
    form.resetFields();
    setPoster("error");
    setBackdrop("error");
    setTmdbId(null);
    setSeasons(null);
  }, [activeKey, visibleAddMovieDrawer]);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    setLoading(true);
    setErrorText(null);

    function callback() {
      setLoading(false);

      setVisibleAddMovieDrawer(false);
      getMovesList();
    }

    function errorCallback(err) {
      // setErrorText(err);
      notification.error({
        message:
          typeof err === "string"
            ? err
            : translate["An error occurred"] || EN["An error occurred"],
      });
      setLoading(false);
    }

    const body = {
      url: values.url,
      price: values.price,
      tmdb_id: tmdbId,
      type: values.type === "Movie" ? "movie" : "tv",
    };

    REQUESTS.VOD.MOVIES.ADD_FROM_TMDB(body, callback, errorCallback);
  };

  const onFinishFailed = () => {
    setErrorText(null);
  };

  const selectMovieFromTmbd = (data) => {
    const genres = data.genres.map((item) => item.name);

    form.setFields([
      { name: "type", value: data.seasons ? "Tv-show" : "Movie" },
      { name: "name", value: data.original_title || data.original_name },
      { name: "categories", value: genres.join(", ") },
      {
        name: "runtime",
        value: data.runtime
          ? data.runtime
          : data.episode_run_time && data.episode_run_time[0] && data.episode_run_time[0],
      },
      { name: "description", value: data.overview },
      { name: "date", value: data.release_date || data.first_air_date },
    ]);

    setPoster(`${TMDB_IMAGE_HOST}${data.poster_path}`);
    setBackdrop(`${TMDB_IMAGE_HOST}${data.backdrop_path}`);
    setTmdbId(data.id);

    setSeasons(data.seasons ? data.seasons : null);
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      align: "center",
      key: "id",
      render: (text, record, index) => index,
    },

    {
      title: translate["Name"] || EN["Name"],
      dataIndex: "name",
      key: "name",
    },

    {
      title: translate["Episode count"] || EN["Episode count"],
      dataIndex: "episode_count",
      key: "episode_count",
    },

    {
      key: "air_date",
      title: translate["Date"] || EN["Date"],
      dataIndex: "air_date",
      render: (text, record, index) => dateFormat(text),
    },
  ];

  return (
    <div style={{ height: "100%" }}>
      <TmdbSearch selectMovieFromTmbd={selectMovieFromTmbd} />
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          price: 0,
        }}
      >
        <div className="movie-form-section">
          <section>
            <div>
              <LabelComponent>{translate["Poster"] || EN["Poster"]}</LabelComponent>

              <div className="tmdb-image-style">
                <Image
                  src={poster}
                  fallback="data:image/png;base64,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"
                />
              </div>
            </div>

            <Form.Item
              label={translate["Name"] || EN["Name"]}
              tooltip={{
                title: "Movie name",
                icon: ICONS.INFO,
              }}
            >
              <Form.Item name="name" noStyle>
                <Input disabled readOnly />
              </Form.Item>
            </Form.Item>

            <Form.Item
              label={translate["Categories"] || EN["Categories"]}
              tooltip={{
                title: "Movie catrgories",
                icon: ICONS.INFO,
              }}
            >
              <Form.Item name="categories" noStyle>
                <Input disabled readOnly />
              </Form.Item>
            </Form.Item>

            <Form.Item
              label={translate["Description"] || EN["Description"]}
              tooltip={{
                title: "Movie description",
                icon: ICONS.INFO,
              }}
            >
              <Form.Item name="description" noStyle>
                <Input.TextArea readOnly disabled style={{ height: 120 }} />
              </Form.Item>
            </Form.Item>
          </section>

          <section>
            <div>
              <LabelComponent>{translate["Backdrop"] || EN["Backdrop"]}</LabelComponent>

              <div className="tmdb-image-style">
                <Image
                  src={backdrop}
                  fallback="data:image/png;base64,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"
                />
              </div>
            </div>

            <Form.Item
              label={translate["Url"] || EN["Url"]}
              tooltip={{
                title: "Url",
                icon: ICONS.INFO,
              }}
              name="url"
            >
              <Input />
            </Form.Item>

            <div className="type-price">
              <Form.Item
                label={translate["Type"] || EN["Type"]}
                tooltip={{
                  title: "Movie type",
                  icon: ICONS.INFO,
                }}
              >
                <Form.Item name="type" noStyle>
                  <Input disabled readOnly />
                </Form.Item>
              </Form.Item>

              <Form.Item
                label={translate["Price"] || EN["Price"]}
                tooltip={{
                  title: "Price",
                  icon: ICONS.INFO,
                }}
                style={{ margin: 0 }}
                name="price"
                rules={[
                  {
                    required: true,
                    message: `${translate["Price"] || EN["Price"]}`,
                  },
                  {
                    pattern: new RegExp(/^\d+$/),
                    message:
                      translate["Price must be a number"] || EN["Price must be a number"],
                  },
                ]}
              >
                <Input type="text" />
              </Form.Item>
            </div>

            <div className="row-block">
              <Form.Item
                label={translate["Date"] || EN["Date"]}
                tooltip={{
                  title: "Date",
                  icon: ICONS.INFO,
                }}
              >
                <Form.Item name="date" noStyle>
                  <Input disabled readOnly />
                </Form.Item>
              </Form.Item>

              <Form.Item
                label={translate["Runtime"] || EN["Runtime"]}
                tooltip={{
                  title: "Runtime",
                  icon: ICONS.INFO,
                }}
              >
                <Form.Item name="runtime" noStyle>
                  <Input disabled readOnly />
                </Form.Item>
              </Form.Item>
            </div>
          </section>
        </div>

        {seasons && (
          <div style={{ marginBottom: 20 }}>
            <Table
              rowKey="id"
              columns={columns}
              dataSource={seasons}
              pagination={false}
            />
          </div>
        )}

        <SaveButtonComponent loading={loading} onClick={() => form.submit()} />
      </Form>

      {/* <ErrorMessage>{errorText}</ErrorMessage> */}
    </div>
  );
}
